/**
 * The browser's IANA timezone, sent as `X-Viewer-Timezone` on every API call.
 *
 * Admins have no stored profile zone, so the backend formats "Your account"
 * times in this one. Undefined when the browser cannot say; the header is then
 * left out and the backend falls back to its configured zone.
 */
export function getViewerTimezone(): string | undefined {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined
  } catch {
    return undefined
  }
}

export function viewerTimezoneHeader(): Record<string, string> {
  const zone = getViewerTimezone()
  return zone ? { "X-Viewer-Timezone": zone } : {}
}
